class XsAtc extends HTMLElement {
    constructor() {
        super();
        const buttons = this.querySelectorAll('.cross-sell-atc');
        if (buttons) {
            buttons.forEach(btn => btn.addEventListener('click', this.addToCart));
            // this.logLoad(this.dataset.handle);
        }
        document.addEventListener('vs:updatedCart', (cart) => {
            this.updateXs(cart.detail.cart)
        });
    }

    logLoad = (handle) => {
        void fetch('/apps/ckc/xs/logload', {
            method: 'POST',
            cache: 'no-cache',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({'trigger': handle}),
        });
    };

    getSectionsToRender = () => {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section',
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.xs-contents',
            },
        ];
    };

    justRenderXs = () => {
        return [
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.xs-contents',
            },
        ];
    };

    getSectionInnerHTML = (html, selector) => {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    };

    updateRegions = (parsedState, sections) => {
        sections.forEach((section) => {
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
            try {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector,
                );
            }catch{
                document.getElementById(section.id).querySelector('.cart__footer--left').innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    '.cart__footer--left',
                );
                document.getElementById(section.id).querySelector('.js-contents').innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    '.js-contents',
                );
                document.querySelector('.cart__blocks cart-note')?.remove();
            }
        });

    };

    addToCart = (evt) => {
        evt.preventDefault();
        evt.target.removeEventListener('click', this.addToCart);
        const add = evt.target.dataset.variantid;
        const sections = this.getSectionsToRender().map((section) => section.section);
        fetch('/cart/add.js', {
            method: 'POST',
            cache: 'no-cache',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                'items': [
                    {
                        'id': add,
                        'quantity': 1,
                        'properties': {
                            '__xs': true,
                        },
                    },
                ],
                sections: sections,
                sections_url: window.location.pathname,
            }),
        }).then((response) => {
            return response.text();
        }).then((state) => {
            const parsedState = JSON.parse(state);
            this.updateRegions(parsedState, this.getSectionsToRender());
        });
    };

    updateXs = (parsedState) => {
        this.updateRegions(parsedState, this.justRenderXs());
    };

}

customElements.define('xs-section',XsAtc);